import React from "react";
import { AurixWordmark } from "@/components/site/Logo";
import { Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const COL_1 = [
  { label: "AURIX STUDIO", href: "#divisions" },
  { label: "AURIX MEDIA", href: "#divisions" },
  { label: "AURIX GROWTH", href: "#divisions" },
  { label: "AURIX FMCG LABS", href: "#divisions" },
];
const COL_2 = [
  { label: "Web Development", href: "#services" },
  { label: "Mobile Apps", href: "#services" },
  { label: "AI Automation", href: "#services" },
  { label: "Digital Marketing", href: "#services" },
];
const COL_3 = [
  { label: "Leadership", href: "#leadership" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
  { label: "Privacy Policy", href: "#" },
];

const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative border-t border-white/[0.06] bg-[#060606] pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <AurixWordmark size={44} />
            <p className="mt-6 max-w-sm text-[14px] leading-relaxed text-zinc-400">
              Building brands. Creating experiences. Growing businesses. One
              project. One partnership. One legacy at a time.
            </p>
            <a
              href="mailto:hrgroupsenterprises@gmail.com"
              className="mt-5 inline-flex items-center text-[13px] text-zinc-400 transition-colors hover:text-[var(--gold-bright)]"
            >
              hrgroupsenterprises@gmail.com
            </a>
            <div className="mt-8 flex items-center gap-3">
              {[Instagram, Linkedin, Twitter, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Social link"
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/10 bg-white/[0.02] text-zinc-400 transition-colors duration-300 hover:border-[var(--gold)]/40 hover:text-[var(--gold-bright)]"
                >
                  <Icon className="h-4 w-4" strokeWidth={1.7} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 lg:col-span-7 lg:grid-cols-3">
            <FooterCol title="Divisions" links={COL_1} />
            <FooterCol title="Services" links={COL_2} />
            <FooterCol title="Company" links={COL_3} />
          </div>
        </div>

        <div className="gold-line mt-16" />

        <div className="mt-6 flex flex-col items-start justify-between gap-3 text-[12.5px] text-zinc-500 sm:flex-row sm:items-center">
          <p>
            © {new Date().getFullYear()} HR ENTERPRISES · All rights reserved.
          </p>
          <p>
            Flagship division: <span className="text-zinc-300">AURIX STUDIO</span> — Websites launched in 48 hours.
          </p>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="font-mono-label mb-4 text-[var(--gold)]">{title}</div>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l.label}>
          <a
            href={l.href}
            className="text-[13.5px] text-zinc-400 transition-colors duration-300 hover:text-white"
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
